import { http } from '@/http/axios.js'
export function getListAPI(params) {
  return http({
    url: '/admin/log/action/page',
    method: 'get',
    params
  })
}
